import { render, staticRenderFns } from "./DonorWall.vue?vue&type=template&id=10b3d616&scoped=true"
import script from "./DonorWall.vue?vue&type=script&lang=js"
export * from "./DonorWall.vue?vue&type=script&lang=js"
import style0 from "./DonorWall.vue?vue&type=style&index=0&id=10b3d616&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b3d616",
  null
  
)

export default component.exports